import React, { FC } from 'react';
import { Checkbox, FormControlLabel, Radio } from '@mui/material';
import { useTheme } from '@mui/material';

import { CheckFilledIcon } from 'src/shared/components';

import { DropdownItemProps } from './Dropdown.types';
import { useDropdownProvider } from './DropdownProvider';

export const DropdownItem: FC<DropdownItemProps> = ({
  label,
  value,
  active: propActive = false,
  disabled,
  type: propType,
  ariaText,
  className,
  style,
  onSelect,
}) => {
  const theme = useTheme();
  const { active: providerActive, type: providerType, onSelect: onSelectProvider } = useDropdownProvider();
  const type = propType ? propType : providerType;
  const active = propActive ? propActive : providerActive;

  const handleSelect = (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(value, !active);
    } else if (onSelectProvider) {
      onSelectProvider(value, !active);
    }
  };

  return (
    <div className={className} style={style}>
      {(type === 'radio' || type === 'checkbox') && (
        <FormControlLabel
          className="small"
          label={<div className="small">{label}</div>}
          disabled={disabled}
          checked={active}
          value={value}
          aria-label={ariaText}
          onChange={handleSelect}
          control={type === 'radio' ? <Radio size="small" /> : <Checkbox size="small" />}
        />
      )}
      {type === 'link' && (
        <div className={disabled ? 'disabled' : undefined} onClick={handleSelect}>
          {label}
        </div>
      )}
      {typeof type === 'undefined' && (
        <div
          className={`d-flex justify-content-between align-items-center ${disabled ? 'disabled' : ''}`}
          aria-label={ariaText}
          onClick={handleSelect}
          style={{ color: active ? theme.palette.primary.main : undefined }}
        >
          <div>{label}</div>
          {active && <CheckFilledIcon size={18} className="ms-3 justify-self-end" />}
        </div>
      )}
    </div>
  );
};
